export interface ISearchArticleResult {
  title: string;
  id: string;
  publishedDate?: Date;
}

export class SearchArticleResult implements ISearchArticleResult {
  constructor(
    public id: string,
    public title: string,
    public publishedDate?: Date,
  ) {}
}
